import { render, staticRenderFns } from "./DraggableText.vue?vue&type=template&id=5717d5fd"
import script from "./DraggableText.vue?vue&type=script&lang=js"
export * from "./DraggableText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports